import { faExclamationTriangle } from '@fortawesome/pro-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import * as Input from 'components/input';
import { EngageDNSRecord, EngageDomain } from 'types/domain';

const DNSRecordTable = (props: { domain: EngageDomain; inPortal: boolean }) => {
    const { domain, inPortal } = props;

    return (
        <div className="mb-3 rounded-xl border border-gray-200">
            <div className="grid grid-cols-4 gap-4 rounded-tl-xl rounded-tr-xl border-b border-gray-200 bg-gray-50 px-6 py-1.5 font-medium text-gray-800">
                <span>Type</span>
                <span>Name</span>
                <span>Value</span>
            </div>
            {domain.records
                .filter((rec: EngageDNSRecord) => !rec.is_hidden)
                .map((rec: EngageDNSRecord) => {
                    const recName = rec.name.replace(new RegExp('.' + domain.value + '$'), '');
                    return (
                        <div
                            key={rec.id}
                            className="grid grid-cols-4 items-center gap-4 px-6 py-1.5 font-medium text-gray-800"
                        >
                            <p>{rec.type.toUpperCase()}</p>
                            <Input.Root>
                                <Input.Form value={recName} readOnly className="min-w-0" />
                                <Input.CopyButton text={recName} inPortal={inPortal} />
                            </Input.Root>
                            <Input.Root>
                                <Input.Form value={rec.value} readOnly className="min-w-0" />
                                <Input.CopyButton text={rec.value} inPortal={inPortal} />
                            </Input.Root>
                            <span className="text-center">
                                {rec.verified_at === null ? (
                                    <span className="whitespace-nowrap rounded-full bg-red-50 px-2 py-1.5 text-xs text-red-500">
                                        <FontAwesomeIcon icon={faExclamationTriangle} /> Not active
                                    </span>
                                ) : (
                                    <span className="whitespace-nowrap rounded-full bg-green-50 px-2 py-1.5 text-xs text-green-500">
                                        Verified
                                    </span>
                                )}
                            </span>
                        </div>
                    );
                })}
        </div>
    );
};

export { DNSRecordTable };
